import InputNumber from './src/input-number';

InputNumber.install = function(Vue) {
  Vue.component(InputNumber.name, InputNumber);
};

export default InputNumber;



// WEBPACK FOOTER //
// ./src/components/input-number/index.js